import { DatePipe } from "@angular/common";
import { Component } from "@angular/core";
import { DespesaService } from "administrativo-lib";
import { SubGrupoEstoqueService } from "almoxarifado-lib";
import { BaseResourceRptComponent, Coluna, EddyAutoComplete, FavorecidoService, FormatoExportacao, GlobalService, LoginContabil, PessoaService, Relatorio, UnidadeService } from "eddydata-lib";
import { takeUntil } from "rxjs/operators";
import { CompraService } from "../../compra/service/compra.service";
import { tsXLXS } from "ts-xlsx-export";

@Component({
  selector: 'lib-compra-rpt',
  templateUrl: './compra-rpt.component.html'
})
export class CompraRptComponent extends BaseResourceRptComponent {

  private loginContail: LoginContabil;

  public ordernacao: { nome: string, coluna: string, ordem: 'DESC' | 'ASC' };
  public listaOrdenacao: { nome: string, coluna: string, ordem: 'DESC' | 'ASC' }[] = [];

  public tipo: 'S' | 'A' = 'S';
  public parametros: { session?: any, filtros?: any } = {};

  protected datepipe: DatePipe;

  constructor(
    private favorecidoService: FavorecidoService,
    private despesaService: DespesaService,
    private pessoaService: PessoaService,
    private unidadeService: UnidadeService,
    private compraService: CompraService,
    private subGrupoService: SubGrupoEstoqueService
  ) {
    super();
  }

  protected afterInit(): void {
    this.datepipe = new DatePipe('pt');
    this.orientacao = "landscape";
    this.listaOrdenacao = this.obterColunasOrdenacoes();
    this.ordernacao = this.listaOrdenacao[0];
    this.loginContail = GlobalService.obterSessaoLogin();
  }

  protected tituloRelatorio(): string {
    return `Ordens de Fornecimento`;
  }

  public obterColunasOrdenacoes(): { nome: string, coluna: string, ordem: 'DESC' | 'ASC' }[] {
    return [
      { coluna: 'numero', nome: 'Número', ordem: 'ASC' },
      { coluna: 'data_compra', nome: 'Data Compra', ordem: 'ASC' },
      { coluna: 'favorecido.nome', nome: 'Fornecedor', ordem: 'ASC' },
      { coluna: 'requerente.nome', nome: 'Requerente', ordem: 'ASC' },
    ];
  }

  protected obterColunasRelatorio(filtro?: boolean): Coluna[] {
    let retorno: Coluna[] = [];
    retorno.push({ titulo: 'Número', coluna: 'numero', alignment: 'center' });
    retorno.push({ titulo: 'Data Compra', coluna: 'data_compra', alignment: 'center' });
    retorno.push({ titulo: 'Nº Requisição', coluna: 'rcms.numero', alignment: 'center' });
    retorno.push({ titulo: 'Fornecedor', coluna: 'favorecido.nome', tipo: 'String' });
    retorno.push({ titulo: 'Ficha', coluna: 'ficha.numero', alignment: 'center' });
    retorno.push({ titulo: 'Despesa', coluna: 'subelemento.codigo', alignment: 'center' });
    retorno.push({ titulo: 'Requerente', coluna: 'requerente.nome', tipo: 'String' });
    retorno.push({ titulo: 'Contrato', coluna: 'contrato.numero', alignment: 'center' });
    retorno.push({ titulo: 'Licitação', coluna: 'licitacao.numero', alignment: 'center' });
    retorno.push({ titulo: 'Processo', coluna: 'processo', alignment: 'center' });
    retorno.push({ titulo: 'Vl. Total', coluna: 'total_compra', alignment: 'right', decimais: 2 });
    // if (this.tipo === 'A' && this.formato == 'pdf') {
    //   retorno.push({
    //     titulo: null, coluna: 'itens', bold: true, fontSize: 14, larguras: [40, '*', 'auto', 50, 50, '*'],
    //     colunas: this.obterColunasAnalitico(), layout: this.layoutItens(),
    //     adicionaisBody: { border: [false, false, false, false], margin: [-3, -2, -3, 0] }
    //   });
    // } else
    retorno = retorno.map((r) => Object.assign(r, { adicionaisBody: { border: [false, false, false, false] } }));
    retorno = retorno.map((r) => Object.assign(r, { adicionaisHeader: { margin: [0, 3, 0, 3] } }));

    return retorno;
  }

  // private obterColunasAnalitico(): Coluna[] {
  //   let retorno: Coluna[] = [];
  //   retorno.push({ titulo: 'Cód.', coluna: 'produto_unidade.produto.codigo', alignment: 'center', });
  //   retorno.push({ titulo: 'Descrição', coluna: 'produto_unidade.produto.nome', alignment: 'left', });
  //   retorno.push({ titulo: 'Unidade', coluna: 'produto_unidade.unidade.nome', alignment: 'center', });
  //   retorno.push({ titulo: 'Qtd.', coluna: 'quantidade', alignment: 'right', decimais: 2, });
  //   retorno.push({ titulo: 'Vl. Unitário', coluna: 'valor_unitario', alignment: 'right', decimais: 2, });
  //   retorno.push({
  //     titulo: 'Vl. Total', coluna: 'valor_total', alignment: 'right', decimais: 2, funcao: [
  //       { valor: ['valor_unitario', '*', 'quantidade'] }
  //     ]
  //   });
  //   retorno = retorno.map((r) => Object.assign(r, { adicionaisBody: { border: [false, false, false, false] }, adicionaisHeader: { border: [true, false, true, true] } }));
  //   return retorno;
  // }

  public obterColunasfiltroPersonalizado(): Coluna[] {
    let retorno: Coluna[] = [];
    retorno.push({ titulo: 'Número', coluna: 'numero', alignment: 'center', tipo: 'Number' });
    retorno.push({ titulo: 'Data Compra', coluna: 'data_compra', tipo: 'Date', alignment: 'center', cols: 12 });
    retorno.push({ titulo: 'Nº Requisição', coluna: 'rcms.numero', alignment: 'center', tipo: 'String', cols: 6 });
    retorno.push({
      titulo: 'Fornecedor', coluna: 'favorecido.id', tipo: 'AutoComplete', autocomplete: new EddyAutoComplete(null, this.favorecidoService,
        'id', ['cpf_cnpj', 'nome'], { cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['id', 'cpf_cnpj'], text: ['nome'] }), cols: 12
    });
    retorno.push({ titulo: 'Ficha', coluna: 'ficha.numero', alignment: 'center', tipo: 'String', cols: 6 });
    retorno.push({
      titulo: 'Despesa', coluna: 'ficha.despesa.codigo', alignment: 'center', tipo: 'AutoComplete', autocomplete: new EddyAutoComplete(null, this.despesaService,
        'codigo', ['codigo', 'nome'], { 'exercicio.id': this.login.exercicio.id, orderBy: 'codigo', nivel: 4 }, { number: ['codigo'], text: ['nome'] }
      ), cols: 12,
    });
    retorno.push({
      titulo: 'Subelemento', coluna: 'subelemento.codigo', alignment: 'center', tipo: 'AutoComplete', autocomplete: new EddyAutoComplete(null, this.despesaService,
        'codigo', ['codigo', 'nome'], { 'exercicio.id': this.login.exercicio.id, orderBy: 'codigo', nivel: 6 }, { number: ['codigo'], text: ['nome'] }
      ), cols: 12,
    });
    retorno.push({
      titulo: 'Requerente', coluna: 'requerente.id', tipo: 'AutoComplete', autocomplete: new EddyAutoComplete(null, this.pessoaService,
        'id', ['nome'], { cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['id', 'cpf_cnpj'], text: ['nome'] }
      ), cols: 12
    });
    retorno.push({ titulo: 'Contrato', coluna: 'contrato.numero', alignment: 'center', tipo: 'String', cols: 6, mask: [{ mask: '0000/0000' }, { mask: '00000/0000' }] });
    retorno.push({ titulo: 'Licitação', coluna: 'licitacao.numero', alignment: 'center', tipo: 'String', cols: 6, mask: '00000/0000' });
    retorno.push({ titulo: 'Processo', coluna: 'processo', alignment: 'center', tipo: 'String', cols: 6, mask: [{ mask: '0000/0000' }, { mask: '00000/0000' }], notUnmask: true });
    retorno.push({ titulo: 'Vl. Total', coluna: 'total_compra', alignment: 'right', tipo: 'Number', decimais: 2 });
    retorno.push({
      titulo: 'Secretaria', coluna: 'setor.unidade.id', tipo: 'AutoComplete', autocomplete: new EddyAutoComplete(null, this.unidadeService,
        'id', ['id', 'nome'], { orderBy: 'nome', 'ppa.id': this.loginContail.ppa.id }, { number: ['id'], text: ['nome'] }), cols: 12
    });
    retorno.push({ titulo: 'Descrição Item', coluna: 'itens.produto_unidade.produto.descricao', tipo: 'String', cols: 6 });
    retorno.push({ titulo: 'Código Item', coluna: 'itens.produto_unidade.produto.codigo', tipo: 'String' });
    retorno.push({
      titulo: 'Subgrupo', coluna: 'itens.produto_unidade.produto.material.sub_grupo.id', tipo: 'AutoComplete',
      autocomplete: new EddyAutoComplete(null, this.subGrupoService,
        'id', ['codigo', 'nome'], { 'orgao_id': this.login.orgao.id, orderBy: 'nome' }, { number: ['codigo'], text: ['nome'] }), cols: 12
    });
    retorno.push({ titulo: 'Compra Direta', coluna: 'contrato.id$null,licitacao.id$null', tipo: 'Boolean' });
    retorno.push({ titulo: 'Anuladas', coluna: 'valid_total_anulado', tipo: 'Boolean' });
    return retorno;
  }

  protected larguraColunas(): (string | number)[] {
    return [40, 60, 60, 'auto', 'auto', 'auto', '*', 50, 50, 50, '*'];
  }

  protected totalizarColunas(): (string | {})[] {
    return ['total_compra'];
  }

  public exportarListagem() {
    let datepipe = new DatePipe('pt');
    let parametros = {
      'orderBy': `${this.ordernacao.coluna}\$${this.ordernacao.ordem}`,
      'orgao.id': this.login.orgao.id, 'exercicio.id': this.login.exercicio.id, 'excluido': false,
      relations: ['favorecido', 'ficha', 'ficha.despesa', 'requerente', 'contrato', 'licitacao', 'rcms',
        'itens', 'itens.produto_unidade', 'itens.produto_unidade.produto', 'itens.produto_unidade.unidade',
        'itens.produto_unidade.produto.material.sub_grupo', 'subelemento'
      ]
    };

    if (this.parametros?.filtros)
      parametros = Object.assign(parametros, this.parametros.filtros);
    if (!parametros['valid_total_anulado'])
      parametros['valid_total_anulado'] = false;

    this.compraService.extendido(1, -1, parametros).pipe(takeUntil(this.unsubscribe))
      .subscribe(async (res) => {

        let lista = res.content.flatMap((c) => {

          if (c.contrato)
            c.contrato.numero = this.funcaoService.mascarar('0000/0000', c.contrato.numero);

          if (c.licitacao)
            c.licitacao.numero = this.formataNumeroDaLicitacao(c.licitacao.numero)

          let total_compra = 0;
          if (c.itens && c.itens.length > 0)
            for (let item of c.itens)
              total_compra += +item.valor_unitario * +item.quantidade;

          c['total_compra'] = total_compra;

          if (!c.itens || c.itens.length === 0 && this.tipo === 'A') {
            c.itens = [{
              produto_unidade: {
                produto: { nome: 'Não possui itens.' }
              }
            }];
          }

          let saida = [c];



          return saida;
        });

        if (this.formato === 'pdf') {
          Relatorio.imprimirPersonalizado('Ordens de Fornecimento',
            this.login.usuario.nome, this.login.usuario.sobrenome, this.login.orgao.nome, this.login.brasao,
            this.montarConteudo(lista), 'landscape', 'Ordens de Fornecimento',
            {
              linhas: {
                hLineWidth() {
                  return 1;
                },
                vLineWidth() {
                  return 1;
                },
                hLineColor() {
                  return 'black';
                },
                paddingLeft() {
                  return 3;
                },
                paddingRight() {
                  return 3;
                }
              }
            }, false, false, this.formato);
          // }
        } else if (this.formato === 'xlsx') {
          const listaItens = [];

          for (const entidade of lista) {
            // Linha principal da entidade
            listaItens.push({
              'Número': entidade?.numero || '',
              'Data Compra': entidade?.data_compra ? datepipe.transform(entidade.data_compra, 'dd/MM/yyyy') : '',
              'Nº Requisição': entidade.rcms?.numero || '',
              'Fornecedor': entidade?.favorecido?.nome || '',
              'Ficha': entidade?.ficha?.numero || '',
              'Despesa': entidade?.subelemento?.codigo || '',
              'Requerente': entidade?.requerente?.nome || '',
              'Contrato': entidade?.contrato?.numero || '',
              'Licitação': entidade?.licitacao?.numero || '',
              'Processo': entidade?.processo || '',
              'Vl. Total': entidade?.total_compra
                ? this.funcaoService.convertToBrNumber(entidade.total_compra, 2)
                : 0,
            });

            // Itens logo abaixo (recuados)
            if (this.tipo === 'A' && entidade.itens?.length > 0) {
              listaItens.push({
                'Número': 'Cód.',
                'Data Compra': 'Descrição',
                'Nº Requisição': 'Unidade',
                'Fornecedor': 'Qtd.',
                'Ficha': 'Vl. Unitário',
                'Despesa': 'Vl. Total',
                'Requerente': '',
                'Contrato': '',
                'Licitação': '',
                'Processo': '',
                'Vl. Total': ''
              });
              for (const item of entidade.itens) {
                listaItens.push({
                  'Número': item?.produto_unidade?.produto?.codigo ? item?.produto_unidade?.produto?.codigo : '', // linha "filha"
                  'Data Compra': item?.produto_unidade?.produto?.nome ? item?.produto_unidade?.produto?.nome : '',
                  'Nº Requisição': item?.produto_unidade?.unidade?.nome ? item?.produto_unidade?.unidade?.nome : '',
                  'Fornecedor': item?.quantidade ? this.funcaoService.convertToBrNumber(item?.quantidade) : 0,
                  'Ficha': item?.valor_unitario ? this.funcaoService.convertToBrNumber(item?.valor_unitario) : '',
                  'Despesa': item.valor_unitario && item.valor_unitario ? this.funcaoService.convertToBrNumber(+item.valor_unitario * +item.valor_unitario) : 0,
                  'Requerente': '',
                  'Contrato': '',
                  'Licitação': '',
                  'Processo': '',
                });
              }
              listaItens.push({
                'Número': '',
                'Data Compra': '',
                'Nº Requisição': '',
                'Fornecedor': '',
                'Ficha': '',
                'Despesa': '',
                'Requerente': '',
                'Contrato': '',
                'Licitação': '',
                'Processo': '',
                'Vl. Total': ''
              });
            }
          }

          tsXLXS().exportAsExcelFile(listaItens).saveAsExcelFile('Ordens de Fornecimento');

        } else {
          this.funcaoService.exportar(this.formato, lista, 'Ordens de Fornecimento', this.obterColunasRelatorio());
        }
      })

  }

  private montarConteudo(lista: any[]) {
    let totalGeral = 0;
    let retorno: {}[] = [];
    let datepipe = new DatePipe('pt');
    const cabecalho = [];

    cabecalho.push([
      { text: 'Número', alignment: 'center', bold: true, border: [true, true, true, true] },
      { text: 'Data Compra', alignment: 'center', bold: true, border: [true, true, true, true] },
      { text: 'Nº Requisição', alignment: 'center', bold: true, border: [true, true, true, true] },
      { text: 'Fornecedor', alignment: 'left', bold: true, border: [true, true, true, true] },
      { text: 'Ficha', alignment: 'center', bold: true, border: [true, true, true, true] },
      { text: 'Despesa', alignment: 'center', bold: true, border: [true, true, true, true] },
      { text: 'Requerente', alignment: 'left', bold: true, border: [true, true, true, true] },
      { text: 'Contrato', alignment: 'center', bold: true, border: [true, true, true, true] },
      { text: 'Licitação', alignment: 'center', bold: true, border: [true, true, true, true] },
      { text: 'Processo', alignment: 'center', bold: true, border: [true, true, true, true] },
      { text: 'Vl. Total', alignment: 'right', bold: true, border: [true, true, true, true] },
    ]);

    for (const entidade of lista) {
      const registro = [];
      registro.push({ text: `${entidade?.numero ? entidade?.numero : ''}`, alignment: 'center', border: this.tipo !== 'A' ? [false, false, false, false] : [true, true, true, true] });
      registro.push({ text: `${entidade?.data_compra ? datepipe.transform(entidade?.data_compra, 'dd/MM/yyyy') : ''}`, alignment: 'center', border: this.tipo !== 'A' ? [false, false, false, false] : [true, true, true, true] });
      registro.push({ text: `${entidade.rcms?.numero ? entidade.rcms?.numero : ''}`, alignment: 'center', border: this.tipo !== 'A' ? [false, false, false, false] : [true, true, true, true] });
      registro.push({ text: `${entidade?.favorecido?.nome ? entidade?.favorecido?.nome : ''}`, alignment: 'center', border: this.tipo !== 'A' ? [false, false, false, false] : [true, true, true, true] });
      registro.push({ text: `${entidade?.ficha?.numero ? entidade?.ficha?.numero : ''}`, alignment: 'center', border: this.tipo !== 'A' ? [false, false, false, false] : [true, true, true, true] });
      registro.push({ text: `${entidade?.subelemento?.codigo ? entidade?.subelemento?.codigo : ''}`, alignment: 'center', border: this.tipo !== 'A' ? [false, false, false, false] : [true, true, true, true] });
      registro.push({ text: `${entidade?.requerente?.nome ? entidade?.requerente?.nome : ''}`, alignment: 'justify', border: this.tipo !== 'A' ? [false, false, false, false] : [true, true, true, true] });
      registro.push({ text: `${entidade?.contrato?.numero ? entidade?.contrato?.numero : ''}`, alignment: 'center', border: this.tipo !== 'A' ? [false, false, false, false] : [true, true, true, true] });
      registro.push({ text: `${entidade?.licitacao?.numero ? entidade?.licitacao?.numero : ''}`, alignment: 'center', border: this.tipo !== 'A' ? [false, false, false, false] : [true, true, true, true] });
      registro.push({ text: `${entidade?.processo ? entidade?.processo : ''}`, alignment: 'center', border: this.tipo !== 'A' ? [false, false, false, false] : [true, true, true, true] });
      registro.push({ text: `${entidade?.total_compra ? this.funcaoService.convertToBrNumber(entidade?.total_compra, 2) : 0}`, alignment: 'right', border: this.tipo !== 'A' ? [false, false, false, false] : [true, true, true, true] });

      cabecalho.push(registro);

      if (this.tipo === 'A' && entidade.itens.length > 0) {
        const linhaExtra = [];
        linhaExtra.push({ text: `Cód.`, bold: true, alignment: 'center', border: [true, true, true, true] })
        linhaExtra.push({ text: `Descrição`, bold: true, colSpan: 5, border: [true, true, true, true] }, '', '', '', '')
        linhaExtra.push({ text: `Unidade`, bold: true, border: [true, true, true, true] })
        linhaExtra.push({ text: `Qtd.`, bold: true, border: [true, true, true, true] })
        linhaExtra.push({ text: `Vl. Unitário`, bold: true, border: [true, true, true, true] })
        linhaExtra.push({ text: `Vl. Total`, bold: true, colSpan: 2, border: [true, true, true, true] }, '')

        cabecalho.push(linhaExtra);
        for (const item of entidade.itens) {
          const registroExtra = [];
          registroExtra.push({ text: `${item?.produto_unidade?.produto?.codigo ? item?.produto_unidade?.produto?.codigo : ''}`, alignment: 'center', border: [false, false, false, false] });
          registroExtra.push({ text: `${item?.produto_unidade?.produto?.nome ? item?.produto_unidade?.produto?.nome : ''}`, colSpan: 5, alignment: 'center', border: [false, false, false, false] }, '', '', '', '');
          registroExtra.push({ text: `${item?.produto_unidade?.unidade?.nome ? item?.produto_unidade?.unidade?.nome : ''}`, alignment: 'center', border: [false, false, false, false] });
          registroExtra.push({ text: `${item?.quantidade ? this.funcaoService.convertToBrNumber(item?.quantidade) : 0}`, alignment: 'center', border: [false, false, false, false] });
          registroExtra.push({ text: `${item?.valor_unitario ? this.funcaoService.convertToBrNumber(item?.valor_unitario) : ''}`, alignment: 'right', border: [false, false, false, false] });
          registroExtra.push({ text: `${item.quantidade && item.valor_unitario ? this.funcaoService.convertToBrNumber(+item.quantidade * +item.valor_unitario) : 0}`, colSpan: 2, alignment: 'right', border: [false, false, false, false] }, '');
          cabecalho.push(registroExtra);
        }
      }
      totalGeral += +entidade?.total_compra;
    }

    const total = [];
    total.push({ text: 'TOTAL GERAL:', colSpan: 10, alignment: 'left', bold: true, border: this.tipo === 'A' ? [true, true, true, true] : [false, false, false, false] }, '', '', '', '', '', '', '', '', '');
    total.push({ text: this.funcaoService.convertToBrNumber(+totalGeral), alignment: 'right', bold: true, border: this.tipo === 'A' ? [true, true, true, true] : [false, false, false, false] });
    cabecalho.push(total);

    retorno.push({
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        headerRows: 1,
        widths: [40, 60, 60, 'auto', 'auto', 'auto', '*', 50, 50, 50, '*'],
        body: cabecalho,
      }
    });

    return retorno;
  }

  protected carregarLista(): Promise<any[]> {
    // let parametros = {
    //   'orderBy': `${this.ordernacao.coluna}\$${this.ordernacao.ordem}`,
    //   'orgao.id': this.login.orgao.id, 'exercicio.id': this.login.exercicio.id, 'excluido': false,
    //   relations: ['favorecido', 'ficha', 'ficha.despesa', 'requerente', 'contrato', 'licitacao', 'rcms',
    //     'itens', 'itens.produto_unidade', 'itens.produto_unidade.produto', 'itens.produto_unidade.unidade',
    //     'itens.produto_unidade.produto.material.sub_grupo', 'subelemento'
    //   ]
    // };

    // if (this.parametros?.filtros)
    //   parametros = Object.assign(parametros, this.parametros.filtros);
    // if (!parametros['valid_total_anulado'])
    //   parametros['valid_total_anulado'] = false;

    // return new Promise((resolve) => {
    //   this.compraService.extendido(1, -1, parametros).pipe(takeUntil(this.unsubscribe))
    //     .subscribe(async (res) => {

    //       let lista = res.content.flatMap((c) => {

    //         if (c.contrato)
    //           c.contrato.numero = this.funcaoService.mascarar('0000/0000', c.contrato.numero);

    //         if (c.licitacao)
    //           c.licitacao.numero = this.formataNumeroDaLicitacao(c.licitacao.numero)

    //         let total_compra = 0;
    //         if (c.itens && c.itens.length > 0)
    //           for (let item of c.itens)
    //             total_compra += +item.valor_unitario * +item.quantidade;

    //         c['total_compra'] = total_compra;

    //         if (!c.itens || c.itens.length === 0 && this.tipo === 'A') {
    //           c.itens = [{
    //             produto_unidade: {
    //               produto: { nome: 'Não possui itens.' }
    //             }
    //           }];
    //         }

    //         let saida = [c];

    //         if (this.formato !== 'pdf' && c.itens && this.tipo === 'A') {
    //           c.itens.forEach(e => {
    //             const qtd = +parseFloat(e.quantidade).toFixed(2);
    //             const val = +parseFloat(e.valor_unitario).toFixed(2);
    //             let item = {
    //               numero: e.produto_unidade?.produto?.codigo,
    //               data_compra: e.produto_unidade?.produto?.nome,
    //               rcms: {
    //                 numero: e.produto_unidade?.unidade?.nome,
    //               },
    //               favorecido: {
    //                 nome: qtd,
    //               },
    //               ficha: {
    //                 numero: val,
    //               },
    //             }
    //             item['total_compra'] = qtd * val;

    //             saida.push(item);
    //           });
    //         }

    //         return saida;
    //       });

    //       resolve(lista);

    //     });
    // });
    return;
  }

  protected layout(): {} {
    return {
      hLineWidth() {
        return 1;
      },
      vLineWidth(i, node) {
        if (this.tipo === 'A')
          return (i === 0 || i === node.table.widths.length) ? 1 : 0;
        else
          return 1;
      },
      hLineColor(i) {
        return i === 1 || i === 0 ? 'black' : '0aaa';
      },
      paddingLeft(i) {
        return 2;
      },
      paddingRight(i, node) {
        return 2;
      }
    };
  }

  private layoutItens() {
    return {
      hLineWidth() {
        return 1;
      },
      vLineWidth(i, node) {
        return 1;
      },
      hLineColor(i) {
        return i === 1 || i === 0 ? 'black' : '0aaa';
      },
      paddingLeft(i) {
        return 2;
      },
      paddingRight(i, node) {
        return 2;
      }
    };
  }


  public filtroTipo(filtro: Coluna[], tipo: 'String' | 'Number' | 'Date' | 'Boolean' | 'HTML') {
    return filtro.filter((f) => f.tipo === tipo);
  }

  public ngClassCols(cols: number, padrao: string): {} {
    let ngClass = {};
    if (cols)
      ngClass[`col-sm-${cols}`] = true;
    else
      ngClass[padrao] = true;
    return ngClass;
  }

  private formataNumeroDaLicitacao(numeroDaLicitacao: string): string {
    let mascara = numeroDaLicitacao.substring(4).length === 4
      ? '0000/0000'
      : '00000/0000'

    return this.funcaoService.mascarar(mascara, numeroDaLicitacao);
  }
}
